<script setup lang="ts">
import { onBeforeUnmount, onMounted } from "vue";
import { PointHistory } from "@/types/worker/PointHistory";
import PointHistoryCard from "@/components/organisms/mypage/PointHistoryCard.vue";

const props = defineProps<{
  pointHistoryList: PointHistory[];
}>();
const emits = defineEmits(["scrollToBottom"]);

onMounted(() => {
  window.addEventListener("scroll", onScroll);
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", onScroll);
});

const onScroll = () => {
  if (
    // 最下部スクロール時
    Math.ceil(window.innerHeight + window.scrollY) >= document.body.offsetHeight
  ) {
    emits("scrollToBottom");
  }
};
</script>

<template>
  <div>
    <ul class="history-list border-top border-outline-color">
      <li v-for="history in pointHistoryList" :key="history.id">
        <PointHistoryCard
          :pointHistory="history"
          data-testid="pointHistoryCard"
        />
      </li>
    </ul>
  </div>
</template>
